import React, { useEffect } from 'react';

import { Routes, Route, useLocation } from 'react-router-dom';
import Home from '../pages/Home/Home';
import FAQs from '../pages/Faqs/FAQs';
import Contact from '../pages/Contact/Contact';
import About from '../pages/About/About';
import MainLayout from '../Layouts/MainLayout';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from '../pages/TermsOfUse/TermsOfUse';

const Index = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path='/' element={<MainLayout />}>
        <Route path='' index element={<Home />} />
        <Route path='/FAQs' element={<FAQs />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<About />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms-of-use' element={<TermsOfUse />} />
      </Route>
    </Routes>
  );
};

export default Index;
